import { getCurrentApiHost } from 'config/environment';
/**
 * Client source for magic / sign-in links (`agent` query on emailed HTTPS URLs).
 * Non-browser agents bounce from the web landing page to the desktop custom scheme.
 */ export const MAGIC_LINK_AGENT = {
    BROWSER: 'browser',
    TAURI: 'tauri'
};
export const normalizeMagicLinkAgent = (agent)=>{
    if (!agent || !agent.trim()) {
        return MAGIC_LINK_AGENT.BROWSER;
    }
    return agent.trim().toLowerCase();
};
export const isNonBrowserMagicLinkAgent = (agent)=>normalizeMagicLinkAgent(agent) !== MAGIC_LINK_AGENT.BROWSER;
/**
 * Build the custom-scheme URL the browser opens so the Tauri app can redeem the token.
 */ export const buildDesktopAuthDeepLink = ({ token, agent, account })=>{
    const params = new URLSearchParams();
    params.set('token', token);
    params.set('agent', normalizeMagicLinkAgent(agent));
    if (account) {
        params.set('account', account);
    }
    return `rocketlane://auth?${params.toString()}`;
};
/**
 * Best-effort tenant slug from the resolved API host (e.g. https://acme.api.rocketlane.com
 * → acme). Reading `getCurrentApiHost()` instead of `window.location.hostname` means this
 * also resolves correctly on localhost, where the page itself has no tenant subdomain but
 * `getCurrentApiHost()` already falls back to a real, reachable tenant host.
 *
 * The `.api.` segment is optional: `updateApiHostForCookies` rewrites the same host state
 * to drop it once cookies are confirmed enabled (acme.api.rocketlane.com → acme.rocketlane.com),
 * and this must keep resolving the tenant slug either way.
 */ export const getDesktopAccountHintFromHost = ()=>{
    const apiHost = getCurrentApiHost();
    if (!apiHost) {
        return null;
    }
    const hostname = apiHost.replace(/^https?:\/\//i, '').replace(/\/$/, '');
    const match = hostname.match(/^([^.]+)\.(?:api\.)?(rocketlane\.com|nitro\.run)$/i);
    if (!match) {
        return null;
    }
    const slug = match[1].toLowerCase();
    return [
        'api',
        'www',
        'app',
        'admin'
    ].includes(slug) ? null : match[1];
};
